import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.scss";
import "./styles/common-style.scss";
import "./i18n";
import { LanguageContextProvider } from "./components/language/languageContext.tsx";
import { UserDetailProvider } from "./hooks/userDetailsContext.tsx";
import PopupProvider from "./utils/comingSoon.tsx";
import { ToastContainer } from "react-toastify";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <LanguageContextProvider>
      <UserDetailProvider>
        <PopupProvider>
          <ToastContainer />
          <App />
        </PopupProvider>
      </UserDetailProvider>
    </LanguageContextProvider>
  </React.StrictMode>
);
